module.exports = __webpack_public_path__ + "static/img/number11.4a24b8fc.png";